import React from 'react';
import {ChipField, ReferenceField, TabbedShowLayout, TextField} from 'react-admin';
import FunctionsIcon from '@mui/icons-material/Functions';
import {propertyRowStyle} from "../../tools_property_row_style";
import {d4UrlSchema} from "../../Env";
import {renderDateField, renderIfExists, renderProperties, renderReferenceField} from '../../d4tools_tab';

function D4FuncTabFunction(props, controllerProps) {
    const {record} = controllerProps;

    // Check if the component should be rendered
    const shouldRender = record &&
        record['@context'] &&
        JSON.stringify(Object.values(record['@context'])).includes(`${d4UrlSchema}/function.jsonld`);

    if (!shouldRender) return null;

    return (
        <TabbedShowLayout.Tab label="Function" icon={<FunctionsIcon/>}>
            <TextField label="Name" source="function:objName"/>
            {renderIfExists(record, "function:description",
                <TextField label="Description" source="function:description"/>
            )}
            {renderReferenceField(record, "function:hasPart", "functions", "Has Part", props)}
            {renderIfExists(record, "function:isPartOf",
                <ReferenceField label="Is Part Of" source="function:isPartOf" reference="functions">
                    <ChipField source="objName" clickable/>
                </ReferenceField>
            )}
            {renderIfExists(record, "function:containedIn",
                <ReferenceField label="Contained In" source="function:containedIn" reference="locations">
                    <ChipField source="objName" clickable/>
                </ReferenceField>
            )}
            {renderReferenceField(record, "function:providesFunction", "functions", "Provides Function", props)}
            {renderReferenceField(record, "function:implementedBy", "products", "Implemented By", props)}
            {renderReferenceField(record, "function:usedBy", "products", "Used By", props)}
            {renderIfExists(record, "function:responsibleOrganisation",
                <ReferenceField label="Responsible Organisation" source="function:responsibleOrganisation"
                                reference="organisations">
                    <ChipField source="objName" clickable/>
                </ReferenceField>
            )}
            {renderIfExists(record, "function:tags", <TextField source="function:tags"/>)}
            {renderReferenceField(record, "function:tags", "tags", "Tags", props)}
            {renderProperties(record, "function:properties", propertyRowStyle)}
            {renderDateField(record, "function:created", "Created")}
            {renderDateField(record, "function:modified", "Modified")}
            {renderDateField(record, "function:expired", "Expired")}
        </TabbedShowLayout.Tab>
    );
}

export default D4FuncTabFunction;
